export default __webpack_public_path__ + "static/media/ic-transfer-in-transit-secondary-dark.2993f7df.svg";